<template>
    <v-container fluid class="pa-0">
    <v-card style="position: absolute; width: 100%">
        <v-card-title>
            {{$t('event.agenda')}}
            <v-spacer></v-spacer>
            <v-btn class="mr-3" :disabled="!selectedAgendas.length || isEditOrderMode" :dark="!!selectedAgendas.length && !isEditOrderMode" color="primary" @click="dialog = true">
                Modify Rain Plan ({{selectedAgendas.length}})
            </v-btn>
            <v-btn v-if="isEditOrderMode" color="red" dark class="ml-3" @click="cancelEditOrder">
                {{$t('Cancel')}}
                <v-icon right>mdi-close-circle-outline</v-icon>
            </v-btn>
            <v-btn v-if="isEditOrderMode" color="green" dark class="ml-3" @click="saveEditOrder">
                {{$t('Save')}}
                <v-icon right>mdi-check</v-icon>
            </v-btn>
            <v-btn v-if="!isEditOrderMode" color="primary" @click="initEditOrder">
                {{$t('Reorder')}}
                <v-icon right>mdi-swap-vertical</v-icon>
            </v-btn>
            <div class="button-spacer"></div>
            <v-btn color="primary" @click="initAddAgenda">
                {{$t('add')}}
                <v-icon right>mdi-plus</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
            <v-data-table
                :headers="headers"
                :loading="isAgendasPending"
                @pagination="currentPagination"
                :items="tableAgendas"
                show-select
                v-model="selectedAgendas"
                >
                <template v-slot:item.title="{value}">
                    {{value}}
                </template>
                <template v-slot:item.scroller="{value}">
                    <div v-show="isEditOrderMode" class="handle"><v-btn icon ><v-icon>drag_handle{{value}}</v-icon></v-btn></div>
                    <div v-show="!isEditOrderMode"></div>
                </template>
                <template v-slot:item.items="{item,value}">
                    {{getLength(item)}}
                </template>
                <template v-slot:item.rain_plan="{item,value}">
                    {{(value) ? 'on' : '-'}}
                </template>
                <template v-slot:item.agenda_type="{value}">
                    {{value}}
                </template>
                <template v-slot:item.actions="{item}">
                    <v-btn color="primary" class="ma-2" :disabled="isEditOrderMode"
                        @click="initEditAgenda(item)">
                        {{$t('edit')}}
                        <v-icon right>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn color="red" :dark="!isEditOrderMode" class="ma-2" :disabled="isEditOrderMode"
                        @click="deleteAgenda(item)">
                        {{$t('delete')}}
                        <v-icon right>mdi-delete</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card-text>

        <v-dialog v-model="showEditAgendaDialog"
            persistent
            fullscreen
            hide-overlay
            :retain-focus="false"
            >
            <v-card id="vCard">
                <v-app-bar fixed dark color="primary">
                    <v-btn icon dark @click="closeEditAgenda">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <span class="app-bar">{{$t('event.agenda')}}</span>
                </v-app-bar>
                <v-container class="pt-16">
                    <v-row>
                        <v-col class="pb-0 mt-3">
                            <v-menu
                                :close-on-content-click="false"
                                :nudge-right="120"
                                transition="scale-transition">
                                <template v-slot:activator="{ on }">
                                    <v-text-field outlined
                                        :label="$t('event_agenda.date')"
                                        :placeholder="$t('event_agenda.date')"
                                        v-model="editingAgendaItem.date"
                                        v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="editingAgendaItem.date"></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_agenda.title')"
                                        :placeholder="$t('event_agenda.title')"
                                        v-model="editingAgendaItem.title"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_agenda.title_tc')"
                                        :placeholder="$t('event_agenda.title_tc')"
                                        v-model="editingAgendaItem.title_tc"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_agenda.title_sc')"
                                        :placeholder="$t('event_agenda.title_sc')"
                                        v-model="editingAgendaItem.title_sc"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-file-input accept="image/*"
                                    :label="$t('event_agenda.banner')"
                                    v-model="editingAgendaItem.banner">
                            <template v-slot:selection="{file}">
                                <v-img :src="getFileUrl(file)"
                                        max-width="250px"
                                        max-height="250px"></v-img>
                            </template>
                        </v-file-input>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_agenda.address')"
                                        :placeholder="$t('event_agenda.address')"
                                        v-model="editingAgendaItem.address"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_agenda.address_tc')"
                                        :placeholder="$t('event_agenda.address_tc')"
                                        v-model="editingAgendaItem.address_tc"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_agenda.address_sc')"
                                        :placeholder="$t('event_agenda.address_sc')"
                                        v-model="editingAgendaItem.address_sc"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_agenda.address_type')"
                                        :placeholder="$t('event_agenda.address_type')"
                                        type="number"
                                        v-model="editingAgendaItem.address_type"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_agenda.agenda_type')"
                                        :placeholder="$t('event_agenda.agenda_type')"
                                        type="number"
                                        v-model="editingAgendaItem.agenda_type"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-text-field outlined
                                        :label="$t('event_agenda.live_stream_link')"
                                        :placeholder="$t('event_agenda.live_stream_link')"
                                        v-model="editingAgendaItem.live_stream_link"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="pb-0">{{$t('event_agenda.intro')}}</v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <froala
                                v-if="showEditor"
                                :config="froalaConfig"
                                v-model="editingAgendaItem.intro"
                            ></froala>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="mt-2 py-0">
                            <v-checkbox
                                :label="$t('event_agenda.is_auto_agenda_group')"
                                v-model="editingAgendaItem.is_auto_agenda_group"
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="pb-0">
                            {{'Guestlist'}}
                        </v-col>
                    </v-row>
                    <v-form ref="importForm" lazy-validation v-model="isImportFormValid">
                    <v-row>
                        <v-col cols="5">
                            <v-file-input
                                outlined
                                prepend-icon=""
                                prepend-inner-icon="$file"
                                accept=".xlsx, .xls, .csv"
                                label="Import File"
                                placeholder="Select..."
                                :rules="importFileRules"
                                v-model="excelFileToBeImported">
                            </v-file-input>
                        </v-col>
                        <v-col cols="5">
                            <v-select
                                v-model="selectedImportField"
                                :items="eventGuestFields"
                                item-text="name"
                                :label="$t('Excel Field for matching imported guests')"
                                :rules="importFieldRules"
                                outlined
                                return-object
                            ></v-select>
                        </v-col>
                        <v-col>
                            <v-btn class="ma-2" color="primary" :disabled="!isImportFormValid" @click="importExcel">
                                {{$t('import')}}
                            </v-btn>
                        </v-col>
                    </v-row>
                    </v-form>
                    <v-row>
                        <v-col class="pt-0">
                            <v-text-field v-model="search"
                                        append-icon="mdi-magnify"
                                        :label="$t('search')"
                                        single-line
                                        hide-details>
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-data-table :headers="eventGuestHeaders"
                                        :search="search"
                                        :loading="!displayReady"
                                        show-select
                                        v-model="selectedEventGuests"
                                        :items="displayGuestList"
                                        :no-data-text="$t('No Guests')"
                                        :sort-by="sortBy"
                                        sort-desc
                                        >
                                <template v-slot:footer>
                                    <hr style="height:1px; border-width:0; color:rgba(0, 0, 0, 0.12); background-color:rgba(0, 0, 0, 0.12)">
                                    <v-col>
                                        <span style="background-color: #eee; padding: 5px 10px; border-radius: 10px;">
                                            Number of selected guests: {{ selectedEventGuests.length }}
                                        </span>
                                    </v-col>
                                </template>
                                <template v-slot:item.createdAt="{value}">
                                    {{DateTime.fromISO(value).toFormat('yyyy-MM-dd HH:mm')}}
                                </template>
                                <template v-slot:item.actions="{item}">
                                    <v-btn color="primary"
                                        :to="{name: 'event-guests-edit', params: {guestId: item.guestId}}">
                                        {{$t('edit')}}
                                        <v-icon right>mdi-pencil</v-icon>
                                    </v-btn>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                    <v-row class="justify-end">
                        <v-label v-if="!selectedAgendaId">
                            {{'Click save to start adding Agenda items'}}
                        </v-label>
                        <div class="saveAgendaEditButton"></div>
                        <v-btn color="primary" @click="saveAgendaEdit">
                            {{$t('save')}}
                        </v-btn>
                        <div class="saveAgendaEditButton"></div>
                    </v-row>
                    <v-row v-if="editingAgendaItem && selectedAgendaId">
                        <v-col>
                            <EventAgendaItemList :agenda-id="editingAgendaItem.id" :speaker-id="speakerId"></EventAgendaItemList>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="importLogShown"
                max-width="640px"
                persistent
                scrollable>
                <v-card>
                    <v-card-title class="justify-center">
                        {{ $t('Import Log') }}
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row style="white-space: pre-line;">
                                {{importLogMsg}}
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" @click="importLogShown = false">{{$t('close')}}</v-btn>    
                    </v-card-actions>
                </v-card>
            </v-dialog>
        <v-dialog v-model="dialog" scrollable max-width="640px">
            <v-card>
                <v-btn color="primary" @click="rainPlan(true)" class="mx-5 mt-5">
                    Turn on rain plan for selected agendas
                </v-btn>
                <v-btn color="red" @click="rainPlan(false)" class="mx-5 my-5">
                    Turn off rain plan for selected agendas
                </v-btn>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-overlay :z-index="999" v-model="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-card>
    </v-container>
</template>
<style scoped>
    .saveAgendaEditButton {
        width:12px;
        height: 50px;
    }
    .button-spacer {
        width:10px;
    }

    .app-bar {
        font-size: 1.25rem; 
        line-height: 1.5; 
        overflow: hidden; 
        text-overflow: ellipsis; 
        white-space: nowrap;
        margin-left: 20px;
    }

</style>
<script>
    import {computed, ref,watch,onMounted} from '@vue/composition-api'
    import {useGet,useFind} from "feathers-vuex";
    import EventAgendaItemList from "./EventAgendaItemList";
    import { cloneDeep,differenceWith } from 'lodash';
    import Sortable from "sortablejs";
    import XLSX from 'xlsx';
    import eConfig from "../../evention-config";
    import froalaConfig from "../../froala-config";
    import axios from 'axios';

    export default {
        name: 'EventAgenda',
        components: {EventAgendaItemList},
        setup(props, {root}) {
            const {Event,EventAgenda,EventGuest,EventAgendaGroup} = root.$FeathersVuex.api;

            const showEditor = ref(false);

            const eventId = computed(() => root.$route.params.eventId);

            const {item: event, isPending} = useGet({model: Event, id: eventId.value});

            const dbColMapping = eConfig.ev_guest.dbColMapping;
            const eventGuestFields = ref( Object.keys(dbColMapping).map((key)=>{return {name: key, value:dbColMapping[key]}}) );

            const eventSpeaker = computed(() => {
                return event.value ? event.value.f_speaker : null;
            });

            const speakerId = computed(() => {
                return eventSpeaker.value && !eventSpeaker.value.__isTemp ? eventSpeaker.value.id : null;
            });
            
            const agendaParams = computed(()=>{
                return {
                    query:{
                        eventId: eventId.value
                    },
                    $sort:{
                        createdAt: -1
                    }
                }
            })
            const {items: agendas, isPending: isAgendasPending} = useFind({
                model: EventAgenda,
                params: agendaParams,
            })
            watch(isAgendasPending,(newVal,oldVal)=>{
                if(!newVal && oldVal){
                    console.log("Agendas:",agendas.value)
                }
            })
            const eventGuestParams = computed(()=>{
                return {
                    query:{
                        eventId: eventId.value,
                        $sort: {
                            createdAt: -1,
                        }
                    }
                }
            })
            const {items: eventGuests, isPending: isEventGuestPending} = useFind({
                model: EventGuest,
                params: eventGuestParams
            })
            console.log("EventGuest:",eventGuests.value)
            const isEditOrderMode = ref(false);
            const didOrderChange = ref(false);
            const editOrderAgendas = ref([]);
            const selectedAgendaId=ref(null);
            const selectedAgendas = ref([]);
            const dialog = ref(false);

            const eventAgendaGroupParams = computed(()=>{
                return {
                    query:{
                        fAgendaId: selectedAgendaId.value,
                    }
                }
            })
            const agendaGroupsQueryWhen = computed(() => {
                return selectedAgendaId.value!=null;
            });
            
            const {items: agendaGroups, isPending: isAgendaGroupsPending} = useFind({
                model: EventAgendaGroup,
                params: eventAgendaGroupParams,
                queryWhen: agendaGroupsQueryWhen
            })
            const selectedEventGuests = ref([]);
            const originalSelectedEventGuests = ref([]);
            // const tableAgendas = computed(()=>{
            //     return agendas?agendas.value:null
            // })

            const displayGuestList = ref([]);
            const displayReady = ref(false);
            const guestAndAgendaGroupReady = computed(()=>{
                return !isAgendaGroupsPending.value && !isEventGuestPending.value
            })
            watch(guestAndAgendaGroupReady,(newVal,oldVal)=>{
                if(newVal && !oldVal){
                    const listOfId = agendaGroups.value.map(e => e.eventGuestId)
                    displayGuestList.value = eventGuests.value.map((eg)=>{
                        if (listOfId.includes(eg.id)) {
                            eg.checked = true
                        } else {
                            eg.checked = false
                        }
                        return eg
                    })
                }
                displayReady.value = true;
            })
            const sortBy = ref('checked');

            const overlay = ref(false);
            watch(isAgendaGroupsPending,(newVal,oldVal)=>{
                if(!newVal && oldVal){
                    let selectedPeople = []
                    console.log("AgendaGroups:",agendaGroups.value)
                    const listOfId = agendaGroups.value.map(e=>e.eventGuestId)
                    for(let i=0;i<eventGuests.value.length;i++){
                        if(listOfId.includes(eventGuests.value[i].id)){
                            selectedPeople.push(eventGuests.value[i])
                        }
                    }
                    selectedEventGuests.value = selectedPeople;
                    originalSelectedEventGuests.value = cloneDeep(selectedPeople)
                }
            });

            const closeEditAgenda = function(){
                showEditAgendaDialog.value = false;
                selectedAgendaId.value = null
            }
            const headers = ref([
                {text: '',value:'scroller',width:80},
                {text: '',value:'data-table-select'},
                {text:'Order',value:'order'},
                {text: 'Title',value:'title'},
                {text: 'Agenda Items',value:'items'},
                {text: 'Agenda Type',value:'agenda_type'},
                {text: 'Rain Plan',value:'rain_plan'},
                {text: 'Live Stream URL',value:'live_stream_link'},
                {text:'',value:'actions', sortable: false},
            ])

            const editingSelectedAgendas = ref([]);
            const rainPlan = async (on) => {
                overlay.value = true;
                let i = selectedAgendas.value.length;
                const promises = [];
                editingSelectedAgendas.value = cloneDeep(selectedAgendas.value);
                while (i--) {
                    if (on) {
                        if (editingSelectedAgendas.value[i].rain_plan) { continue; }
                        editingSelectedAgendas.value[i].rain_plan = true;
                    } else {
                        if (!editingSelectedAgendas.value[i].rain_plan) { continue; }
                        editingSelectedAgendas.value[i].rain_plan = false;
                    }
                    promises.push(
                        editingSelectedAgendas.value[i].save()
                    );
                }
                await Promise.all(promises).then(() => {
                    root.$store.dispatch('showSnackBar', root.$t('event_agenda.save_successful'));
                }, root.$handleFeatherError.bind(root));
                dialog.value = false;
                overlay.value = false;
            }

            const previewHtmlContentOption = {
                 modules: {
                    toolbar: false,
                },
                placeholder: '',
                theme: 'bubble',
            };

            const editingAgendaItem = ref(new EventAgenda({eventId: eventId.value}))
            const showEditAgendaDialog = ref(false);

            const initEditAgenda = function(agenda){
                console.log("Agenda:",agenda)
                editingAgendaItem.value = agenda
                showEditAgendaDialog.value = true
                selectedAgendaId.value = agenda.id
            }
            const initAddAgenda = function(){
                showEditAgendaDialog.value = true
                editingAgendaItem.value = new EventAgenda({eventId: eventId.value})
                selectedEventGuests.value = []
                originalSelectedEventGuests.value = []
                selectedAgendaId.value = null
                editingAgendaItem.value.is_auto_agenda_group = true
                editingAgendaItem.value.order = agendas.value.length + 1
            }

            // Import
            const importForm = ref(null);
            const isImportFormValid = ref(false);
            const importFieldRules = ref([
                value => !!value || 'Required'
            ]);
            const importFileRules = ref([
                value => !!value || 'Required'
            ]);

            const selectedImportField = ref(null);
            const excelFileToBeImported = ref(null);
            const importLogMsg = ref('');
            const importLogShown = ref(false);

            let currentExcelData = null;

            const readXLSX = (file) => {
                let nameSplit = file.name.split('.');
                let format = nameSplit[nameSplit.length - 1];
                if (!['xls', 'xlsx', 'csv'].includes(format)) {
                    return false;
                }
                return new Promise((resolve) => {
                    let reader = new FileReader();
                    reader.readAsBinaryString(file);
                    reader.onload = function (evt) {
                        let data = evt.target.result;
                        var workbook = XLSX.read(data, {type: 'binary'});
                        let excelData = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], {defval: ''});
                        resolve(excelData);
                    }
                });
            }
            const importExcel = async () => {
                overlay.value = true;
                if (!importForm.value.validate())
                    return false;

                const f = excelFileToBeImported.value;

                if (f) {
                    const excelData = await readXLSX(f);
                    const resultDatas = [];

                    for (let rowObj of excelData) {
                        if (!rowObj.hasOwnProperty(selectedImportField.value.name)) {
                            root.$store.dispatch('showSnackBar', root.$t('No corresponding excel field in your Excel'));
                            return false;
                        }
                        if (rowObj[selectedImportField.value.name] == null || rowObj[selectedImportField.value.name] == undefined) {
                            root.$store.dispatch('showSnackBar', root.$t('Invalid value in your Excel'));
                            return false;
                        }
                        resultDatas.push(rowObj[selectedImportField.value.name]);
                    }

                    if (resultDatas && resultDatas.length >= 1) {
                        currentExcelData = excelData;
                    }

                    const egArr = eventGuests.value.filter(eg => resultDatas.includes(eg[selectedImportField.value.value]))

                    selectedEventGuests.value = egArr;

                    importLogMsg.value = '';
                    importLogMsg.value = `Imported ${egArr.length} guest(s).`;

                    const notFoundEventGuests = differenceWith(currentExcelData, selectedEventGuests.value, function(a, b) {
                        return a[selectedImportField.value.name] === b[selectedImportField.value.value];
                    });

                    if (notFoundEventGuests.length > 0) {
                        importLogMsg.value += `\n\n${notFoundEventGuests.length} guest(s) cannot be found.\n`;
                        notFoundEventGuests.forEach(eg=>{
                            importLogMsg.value += `\n- ${selectedImportField.value.name}: "${eg[selectedImportField.value.name]}"`;
                        });
                    }

                    overlay.value = false;
                    importLogShown.value = true;
                }
                overlay.value = false;
            };

            const saveAgenda = async function(){
                if( editingAgendaItem.value.banner instanceof File){
                    editingAgendaItem.value.banner = {src:await root.$uploadFile(editingAgendaItem.value.banner)};
                }
                if (!editingAgendaItem.value.banner) {
                    editingAgendaItem.value.banner = null;
                }
                editingAgendaItem.value.save().then(()=>{
                    root.$store.dispatch('showSnackBar', root.$t('event_agenda.save_successful'));
                }, root.$handleFeatherError.bind(root));
            }

            const deleteAgenda = function(item){
                if(confirm(root.$t('agenda.confirm_delete'))){
                    item.remove().then(()=>{
                        root.$store.dispatch('showSnackBar', root.$t('event_agenda.delete_successful'));
                    }, root.$handleFeatherError.bind(root));
                }
            }
            const getLength = function(item){
                return item?(item.items?item.items.length:0):0
            }

            const eventGuestHeaders = ref([
                {text: root.$t('First Name'), value: 'ev_firstname'},
                {text: root.$t('Last Name'), value: 'ev_lastname'},
                {text: root.$t('Email'), value: 'ev_email'},
                // {text: '', value: 'actions', filterable: false, width: '120', align: 'end'},
            ]);

            const findAgendaGroupItemByGuest = function(guestId,agendaId){
                for(let i=0;i<agendaGroups.value.length;i++){
                    if(agendaGroups.value[i].eventGuestId === guestId && agendaGroups.value[i].fAgendaId === agendaId){
                        return agendaGroups.value[i];
                    }
                }
                return null
            }

            const saveAgendaGroup = async function(){
                let addedGuests = differenceWith(selectedEventGuests.value, originalSelectedEventGuests.value,(a,b)=>{
                    return a.id===b.id
                });
                let removedGuests = []
                if(!originalSelectedEventGuests.value || !selectedEventGuests.value){
                    //
                }else{
                    removedGuests = differenceWith(originalSelectedEventGuests.value,selectedEventGuests.value,(a,b)=>{
                        return a.id === b.id;
                    });
                }
                overlay.value = true;
                const addedGuests_json = addedGuests.map(e => {
                    return {
                        fAgendaId: editingAgendaItem.value.id,
                        eventGuestId: e.id
                    }
                })
                const removedGuests_json = removedGuests.map(e => {
                    return {
                        fAgendaId: editingAgendaItem.value.id,
                        eventGuestId: e.id
                    }
                })
                
                let response;
                if (addedGuests.length > 0) {
                    try {
                        const prefixUrl = process.env.VUE_APP_SERVER_ADDRESS;
                        response = await axios.create({
                            headers: {'Authorization': window.localStorage.getItem('feathers-jwt')}
                        }).post(`${prefixUrl}/batch-update-api/batch-update`, {
                            service: 'f-agenda-groups',
                            instances: addedGuests_json,
                            operation: 'create'
                        });
                    } catch (e) {
                        root.$handleFeatherError(e);
                        root.$store.dispatch('showSnackBar', 'Server Error while adding guests.');
                        overlay.value = false;
                        return;
                    }
                    if (response.data.error) {
                        overlay.value = false;
                        root.$store.dispatch('showSnackBar', response.data.error);
                        return;
                    }
                }

                if (removedGuests.length > 0) {
                    try {
                        const prefixUrl = process.env.VUE_APP_SERVER_ADDRESS;
                        response = await axios.create({
                            headers: {'Authorization': window.localStorage.getItem('feathers-jwt')}
                        }).post(`${prefixUrl}/batch-update-api/batch-update`, {
                            service: 'f-agenda-groups',
                            instances: removedGuests_json,
                            operation: 'delete'
                        });
                    } catch (e) {
                        root.$handleFeatherError(e);
                        root.$store.dispatch('showSnackBar', 'Server Error while removing guests.');
                        overlay.value = false;
                        return;
                    }
                    if (response.data.error) {
                        overlay.value = false;
                        root.$store.dispatch('showSnackBar', response.data.error);
                        return;
                    }
                }

                EventAgenda.get(editingAgendaItem.value.id)
                originalSelectedEventGuests.value = cloneDeep(selectedEventGuests.value)
                root.$store.dispatch('showSnackBar', root.$t('event_agenda.save_successful'));
                overlay.value = false;
            }

            const saveAgendaEdit = async function(){
                if( editingAgendaItem.value.banner instanceof File){
                    editingAgendaItem.value.banner = {src:await root.$uploadFile(editingAgendaItem.value.banner)};
                }
                if (!editingAgendaItem.value.banner) {
                    editingAgendaItem.value.banner = null;
                }
                editingAgendaItem.value.save().then(async (savedAgenda)=>{
                    editingAgendaItem.value = savedAgenda
                    selectedAgendaId.value = savedAgenda.id
                    await saveAgendaGroup()
                })

            }
            const initEditOrder = function(){
                didOrderChange.value = false
                isEditOrderMode.value = true
                editOrderAgendas.value = cloneDeep(sortedAgendas.value)
            }

            const saveEditOrder =  async function(){
                if(!didOrderChange.value){
                    isEditOrderMode.value = false
                    return;
                }

                overlay.value = true
                console.log("editOrderAgendas:",editOrderAgendas.value)
                for(let i=0;i<editOrderAgendas.value.length;i++){
                    await editOrderAgendas.value[i].save().then(()=>{
                        EventAgenda.get(editOrderAgendas.value[i].id)
                    })
                }
                isEditOrderMode.value = false
                overlay.value = false;
            }

            const cancelEditOrder = function(){
                isEditOrderMode.value = false
            }
            const quickSortAgendas = function(sortAgendas){
                if(sortAgendas.length<2){
                    return sortAgendas
                }

                const chosenIndex = sortAgendas.length - 1
                const chosen  = sortAgendas[chosenIndex]
                const a = []
                const b = []
                for(let i=0;i<chosenIndex;i++){
                    const temp = sortAgendas[i].order
                    temp < chosen.order ? a.push(sortAgendas[i]) : b.push(sortAgendas[i])
                }
                const output = [...quickSortAgendas(a),chosen,...quickSortAgendas(b)]
                return output
            }

            const sortedAgendas = computed(()=>{
                return quickSortAgendas(agendas.value)
            })
            const currentStart = ref(0);// Holds the index of starting item in speakerItemList in the current page of v-table
            const currentPagination = function(e){ // Update current page
                currentStart.value=e.pageStart
            }
            onMounted(() => {
                let table = document.querySelector('.v-data-table tbody');
                Sortable.create(table,
                    {
                        handle:".handle", // Look for class with name "handle"
                        onEnd({newIndex,oldIndex}){
                            didOrderChange.value = true;
                            newIndex +=  currentStart.value;
                            oldIndex +=  currentStart.value;
                            const rowSelected = editOrderAgendas.value.splice(oldIndex,1)[0];
                            editOrderAgendas.value.splice(newIndex,0,rowSelected);

                            for(let i=0;i<editOrderAgendas.value.length;i++){
                                editOrderAgendas.value[i].order = i+1
                            }
                            editOrderAgendas.value = quickSortAgendas(editOrderAgendas.value);
                        }
                    }
                )
            });

            watch(showEditAgendaDialog, (newVal, oldVal) => {
                if (newVal) {
                    document.getElementById('vCard').scrollIntoView();
                }
            })

            const tableAgendas = computed(()=>{
                return isEditOrderMode.value?editOrderAgendas.value:sortedAgendas.value
            })
            return {
                showEditor,
                froalaConfig,

                headers,
                tableAgendas,
                isAgendasPending,
                previewHtmlContentOption,
                isEditOrderMode,
                currentPagination,

                editingAgendaItem,
                showEditAgendaDialog,
                closeEditAgenda,
                initEditAgenda,
                initAddAgenda,
                selectedAgendaId,

                saveAgenda,
                deleteAgenda,
                getLength,
                saveAgendaGroup,
                saveAgendaEdit,

                initEditOrder,
                saveEditOrder,
                cancelEditOrder,

                isEventGuestPending,
                selectedEventGuests,
                eventGuests,
                eventGuestHeaders,
                overlay,
                getFileUrl: root.$getFileURL,
                
                search: ref(''),

                eventSpeaker,
                speakerId,
                selectedAgendas,
                rainPlan,
                dialog,
                editingSelectedAgendas,

                eventGuestFields,
                importForm,
                isImportFormValid,
                importFileRules,
                importFieldRules,
                excelFileToBeImported,
                selectedImportField,
                importLogMsg,
                importExcel,
                importLogShown,

                displayReady,
                displayGuestList,
                sortBy,
            }
        },
        mounted() {
            setTimeout(() => {
                this.showEditor = true;
            }, 100);
        }
    }
</script>